export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          关于桃花影院
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          让每一个人都能自由享受影视的魅力
        </p>

        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50 font-heading text-2xl font-bold mb-4">
                桃
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-[640px]">
                桃花影院成立于2022年，秉持"免费、高清、流畅"的核心理念，致力于为广大影视爱好者打造一个零门槛、高品质的在线观影平台。我们相信，好的影视内容应该被更多人看到，不应该被会员费和订阅费所阻碍。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
              <div className="text-center p-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-2">
                  <i className="ri-movie-2-line text-lg"></i>
                </div>
                <div className="text-lg font-heading font-bold text-foreground-950">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源总量</div>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-2">
                  <i className="ri-user-heart-line text-lg"></i>
                </div>
                <div className="text-lg font-heading font-bold text-foreground-950">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃观众</div>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-200 text-secondary-600 mx-auto mb-2">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <div className="text-lg font-heading font-bold text-foreground-950">3年</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营时长</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}